// Kft consultation bookings always go to Nina (no more load-balancing across
// customer agents for this path — see CommonKftInterstitial /
// CommonKftCegjelzoInterstitial, which open this link directly instead of the
// BookingSlots day-tile picker used elsewhere in the app).
export const CAL_COM_KFT_URL =
  "https://cal.com/team/bookkeepie-magyarorszag/bookkeepie-ugyintezes-idopontfoglalas-delelott";
